import { PetroleumTheme } from "../.internal/themes/PetroleumTheme";
export default PetroleumTheme;
